import { TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID } from "../constants";
import TemplateDeploymentStacksNameCell from "./NameCell";
import TemplateDeploymentStacksStateCell from "./StateCell";
import TemplateDeploymentStacksRowActionsCell from "./RowActionsCell";

export const TEMPLATE_DEPLOYMENT_STACKS_TABLE_CELLS = {
  [TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.STATE]: TemplateDeploymentStacksStateCell,
  [TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.NAME]: TemplateDeploymentStacksNameCell,
  [TEMPLATE_DEPLOYMENT_STACKS_COLUMN_ID.DROPDOWN]: TemplateDeploymentStacksRowActionsCell,
};
